import { Batch } from './batch';

export class Drug {
    _id: string;
    name: string;
    category: string;
    qty: number;
    price: number;
    status: string;
    updated_at: string;
    manufacturer: string;
    threshold_qty: number;
    supplier: string;
    instructions: string;
    batches: Batch[];
}
